import { createRoot } from 'react-dom/client';
import TracingList from '../components/TracingList';

const init = () => {
    const query = new URLSearchParams(window.location.search);
    createRoot(document.getElementById('tracing-list')).render(<TracingList search={query.get('paciente')} />);
};

export default init;
